// extracted by mini-css-extract-plugin
export var content = "_op-1";
export var fullScreen = "_op-0";